export default __webpack_public_path__ + "static/media/whatIsMooni.5a35be1c.png";